module.exports = __webpack_public_path__ + "img/d5.b59003d4.webp";